import { Injectable } from '@angular/core';

import { SessionStorageService } from '../../../../core/services/web-storage';
import { ClienteAnaliseMercadoFilter } from '../../adapters';
import { ClienteAnaliseMercadoFilterStorage } from './cliente-analise-mercado-filter-storage';

/**
 * Service utilizado para armazenar os dados do filter da análise de mercado de cliente no session storage do navegador
 */
@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoFilterStorageService {
    private key = 'clienteAnaliseMercadoFilter';

    constructor(private sessionStorageService: SessionStorageService) { }

    /** Obtem os dados do filtro armazenados */
    get(): ClienteAnaliseMercadoFilterStorage {
        const data = this.sessionStorageService.getObject(this.key) as ClienteAnaliseMercadoFilterStorage;
        if (data) {
            // Criando um Map com os campos filtrados e seus respectivos valores
            data.filterValues = new Map();
            const keys = Object.keys(data.filter);
            keys.forEach(key => data.filterValues.set(key, data.filter[key]));
        }

        return data;
    }

    /** Armazena os dados do filtro */
    set(filter: ClienteAnaliseMercadoFilter) {
        const data = new ClienteAnaliseMercadoFilterStorage(filter);
        this.sessionStorageService.setObject(this.key, data);
    }

    /** Remove os dados do filtro */
    remove() {
        this.sessionStorageService.remove(this.key);
    }

    /** Aplica o filtro armazenado no objeto do filtro informado */
    applyFilter(filter: ClienteAnaliseMercadoFilter) {
        const filterStorage = this.get();
        if (filterStorage != null) {
            // Se possuir os dados, então setamos o filtro com os seus valores armazenados
            if (filter) {
                filterStorage.filterValues.forEach((value, key) => filter[key] = value);
            }
        }
    }
}
